module.exports = __webpack_public_path__ + "img/nogo12drop-min.a0431b57.jpg";